import React from "react";
import { StyledSettingsContainer } from "../common/_components";
import { Box, Grid, Stack } from "@mui/material";
import { getIsMobileApp } from '../../utils/mobileApp';
import moment from "moment";
import { SitesResponse, SlateResponse, SportsResponse } from "../common/store/types";
import { connect, useSelector } from "react-redux";
import { useGetSlateInfoQuery, useGetSlates } from "../common/queries/slateQueries";
import DataHubSettingsSelectors from "./DataHubSettingsSelectors";
import { AuthResponse } from "../preContest/store/types";
import { APIState } from "../utils/api/reducer";
import UnauthenticatedView from "../common/UnauthenticatedView";
import { APIConstants } from "../utils/api/constants";
import { SettingsLoader } from "../common/SettingsLoader";
import { userSubscribed } from "../utils/authentication";

interface OwnProps {
  readonly app?: string;
}

interface ReduxProps {
  readonly selectedSport: SportsResponse;
  readonly selectedSite: SitesResponse;
  readonly selectedSlate: SlateResponse;
  readonly selectedType: string;
  readonly authenticated: APIState<AuthResponse>;
}

type Props = ReduxProps & OwnProps;

export const Settings = (props: Props) => {
  const {
    selectedSlate,
    authenticated,
    app
  } = props;
  const { selectedSite, selectedSport } = useSelector((state: any) => state.common);
  const { isLoading: slatesLoading } = useGetSlates(app || 'CONESTSIM', false);
  const { data: updateInfo } = useGetSlateInfoQuery(selectedSlate?.slateId?.toString(), selectedSlate?.slateId === undefined)
  const isUserSubscribed = userSubscribed(authenticated, selectedSite, selectedSport);
  const isMobileApp = getIsMobileApp();
  if (authenticated.status === APIConstants.STARTED || slatesLoading) {
    return (
      <SettingsLoader />
    )
  }

  if (!isUserSubscribed && !isMobileApp) {
    return <UnauthenticatedView title="Data Hub" app={app || 'CONTESTSIM'} backgroundColor='rgba(125, 125, 125, .25)' />;
  }

  return (
    <StyledSettingsContainer>
      <Grid container style={{ backgroundColor: isMobileApp ? 'transparent' : 'rgba(125, 125, 125, .25)'}}>
        <Grid container item xs={12}>
          <Stack width={'100%'} direction={{xs: 'column', sm: 'row'}} alignItems='start' display='flex' justifyContent={{xs: 'flex-start', sm: 'space-between'}} p={{ xs: isMobileApp ? '8px 0' : '16px 0', sm: '16px 16px' }} gap={1}>
            <DataHubSettingsSelectors app={app || 'CONTESTSIM'} />
            <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap" paddingRight={2} paddingLeft={{ xs: 2, sm: 0 }}>
              {updateInfo?.projectionsLastUpdated && (
                <Box fontSize={10} color={"#BCBCBC"}>
                  Projections: {moment.utc(updateInfo?.projectionsLastUpdated).local().format("M/D h:mm A")}
                </Box>
              )}
              {updateInfo?.projectionsLastUpdated && updateInfo?.ownershipLastUpdated && (
                <Box sx={{ width: '1px', height: '10px', backgroundColor: '#BCBCBC', opacity: 0.4 }} />
              )}
              {updateInfo?.ownershipLastUpdated && (
                <Box fontSize={10} color={"#BCBCBC"}>
                  Ownership: {moment.utc(updateInfo?.ownershipLastUpdated).local().format("M/D h:mm A")}
                </Box>
              )}
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </StyledSettingsContainer>

  );
}

const mapDispatchToProps = {
};

const mapStateToProps = (state: any) => ({
  selectedSlate: state.common.selectedSlate,
  authenticated: state.common.authenticated,
  selectedSport: state.common.selectedSport,
  selectedSite: state.common.selectedSite,
  selectedType: state.common.selectedType,
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);